import { useTranslation } from "react-i18next";

import { Link } from "@mui/material";
import SVG from "react-inlinesvg";

import ReportIcon from "../../assets/icons/report.svg";


const linkColor: string = process.env.REACT_APP__UI_CUSTOMIZATION__REPORT_ERROR_TEXT_COLOR || "#EF1B1B";
const linkHref: string = `mailto:${process.env.REACT_APP_REPORT_ERROR_MAILTO || "cs@smartretail.co"}`;

export const ReportErrorLink = () => {
  const { t } = useTranslation();

  return (
    <Link
      href={linkHref}
      color={linkColor}
      underline="none"
      sx={{
        textAlign: "center", // Centered horizontally
        marginTop: 1, // 8px
      }}
      aria-label="To report error, send an email to us."
    >
      <SVG
        src={ReportIcon}
        fill="currentColor"
        title="Report Error"
        style={{
          marginRight: 4,
          verticalAlign: "middle",
          height: "1em", /* match font size */
          width: "1em",
        }}
      />
      {t("reportError")}
    </Link>
  );
};
